import { http } from '../../http';

const DEFAULT_APP_COUNTRY = 'da'

export default {
    namespaced: true,
    state: {
        countries: [],
        hasLoaded: false,
        isLoading: false
    },
    
    mutations: {
        setCountries (state, countries) {
            state.countries = countries
        },
        setHasLoaded (state, hasLoaded) {
            state.hasLoaded = hasLoaded
        },
        setIsLoading (state, isLoading) {
            state.isLoading = isLoading
        }
    },

    getters: {
        countries: (state) => {
            return Object.keys(state.countries).map((country) => {
                let countryCode = country

                if (countryCode === 'da') {
                    countryCode = 'dk'
                } else if (countryCode === 'en') {
                    countryCode = 'gb'
                }

                return {
                    id: country,
                    text: trans(`countries.${countryCode.toUpperCase()}`)
                }
            })
            .sort((a, b) => {
                return a.text.localeCompare(b.text)
            })
        },
        hasLoaded: (state) => state.hasLoaded,
        defaultUserCountry: (state, getters, rootState) => rootState.auth && rootState.auth.owner ? rootState.auth.owner.country : DEFAULT_APP_COUNTRY,
        getByCode: (state, getters) => (key) => {
            const country = getters.countries.find((country) => country.id === key)

            return country ? country.text : null
        }
    },

    actions: {
        getCountries ({ state, commit }) {
            // Prevent multiple countries request if they're sent at the same time
            if (state.hasLoaded || state.isLoading) {
                return;
            }

            commit('setIsLoading', true)

            http.get('/signup/countries')
                .then(({ data }) => {
                    commit('setCountries', data)
                    commit('setHasLoaded', true)
                    commit('setIsLoading', false)
                }).catch(() => {
                    commit('setHasLoaded', true)
                    commit('setIsLoading', false)
                })
        }
    }
};
